import { render, staticRenderFns } from "./DownloadLabel.vue?vue&type=template&id=db01bca6&"
import script from "./DownloadLabel.vue?vue&type=script&lang=js&"
export * from "./DownloadLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports